//#region src/epson_barcode_format.ts
var EpsonBarcodeFormat = /* @__PURE__ */ function(EpsonBarcodeFormat) {
	EpsonBarcodeFormat[EpsonBarcodeFormat["UPC_A"] = 0] = "UPC_A";
	EpsonBarcodeFormat[EpsonBarcodeFormat["UPC_E"] = 1] = "UPC_E";
	EpsonBarcodeFormat[EpsonBarcodeFormat["EAN13"] = 2] = "EAN13";
	EpsonBarcodeFormat[EpsonBarcodeFormat["JAN13"] = 3] = "JAN13";
	EpsonBarcodeFormat[EpsonBarcodeFormat["EAN8"] = 4] = "EAN8";
	EpsonBarcodeFormat[EpsonBarcodeFormat["JAN8"] = 5] = "JAN8";
	EpsonBarcodeFormat[EpsonBarcodeFormat["CODE128"] = 10] = "CODE128";
	return EpsonBarcodeFormat;
}(EpsonBarcodeFormat || {});
//#endregion
export { EpsonBarcodeFormat };

//# sourceMappingURL=epson_barcode_format.js.map